/**
 * Static defaults + helpers for `ManualBookingDialog`. Pulled out so the
 * main file can stay focused on flow logic.
 */

// 7:00–22:30 in 30-min increments. Most rentals fall in this window; manual
// bookings rarely need 24h granularity, so we keep the list short for the UI.
export const TIME_OPTIONS = (() => {
  const out = [];
  for (let h = 7; h <= 22; h++) {
    for (const m of [0, 30]) {
      const hh = String(h).padStart(2, "0");
      const mm = String(m).padStart(2, "0");
      out.push(`${hh}:${mm}`);
    }
  }
  return out;
})();

import { toLocalIso } from "@/lib/localDate";

/** Initial form values. Defaults to a 2-day rental starting tomorrow. */
export function initialManualBookingForm() {
  const today = new Date();
  const tomorrow = new Date(today); tomorrow.setDate(tomorrow.getDate() + 1);
  const dayAfter = new Date(today); dayAfter.setDate(dayAfter.getDate() + 3);
  return {
    car_id: "",
    pickup_location: "",
    dropoff_location: "",
    start_date: toLocalIso(tomorrow),
    end_date: toLocalIso(dayAfter),
    pickup_time: "12:00",
    return_time: "12:00",
    insurance_plan_id: null,
    add_on_ids: [],
    customer_name: "",
    customer_email: "",
    customer_phone: "",
    customer_address: "",
    customer_country: "",
    customer_id_number: "",
    customer_license_number: "",
    customer_license_expiry: "",
    payment_status: "paid",
    notes: "",
  };
}
